import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {AdService} from '@services/ad.service';
import {SearchParams, UserSearch} from '@models/search';
import {AuthenticationService} from '@services/authentification.service';
import {OnboardingService} from '@services/onboarding.service';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-save',
    templateUrl: './save.component.html',
    styleUrls: ['./save.component.scss']
})
export class SaveComponent implements OnInit {

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
    });
    currentSearch: UserSearch;
    searchParams: SearchParams;
    loading = false;

    constructor(
        private adService: AdService,
        private authenticationService: AuthenticationService,
        private onboardingService: OnboardingService,
        private alertService: AlertService,
        public dialogRef: MatDialogRef<SaveComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.searchParams = this.data.searchParams;
        this.currentSearch = this.data.userSearch;

        this.favoriteForm = new UntypedFormGroup({
            title: new UntypedFormControl(''),
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.loading == false) {
            this.loading = true
            const newUserSearch: UserSearch = {
                id: null,
                title: this.favoriteForm.get('title').value,
                search_ad_params: this.searchParams,
                frequency_alert: '0',
                price_alert: false,
            };

            // Force alert by default
            if (this.authenticationService.isAllowed('expert')) {
                newUserSearch.frequency_alert = '4';
            } else if (this.authenticationService.isAllowed('essentiel')) {
                newUserSearch.frequency_alert = '1';
            }

            this.adService.addUserSearch(newUserSearch).subscribe((us) => {
                this.dialogRef.close({currentSearch: us});
                if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.show_list_search == false) {
                    this.onboardingService.showSearchSaveList();
                }
            }, error => {
                this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                console.log(error);
                this.loading = false;
            });
        }
    }
}
